export type Attendee = {
  guestId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string;
  linkedinUrl: string | null;
  superpower: string | null;
  challenge: string | null;
  solution: string | null;
  photoUrl: string | null;
};

export const findByGuestId = (
  guestId: string,
  attendees: readonly Attendee[],
): Attendee | null => {
  return attendees.find((a) => a.guestId === guestId) ?? null;
};

export { clearSession } from "./api";
